const initState = {
    masters: []
};
const masterReducer = (state = initState, action) => {
    return state;
};

export default masterReducer;